














































import { Component, Vue } from "vue-property-decorator";
import { RimRepairLayoutComponent } from "@/components/common";
import { IUser, UserRoles } from "@/interfaces";
import { makeUser } from "@/utils";
import { GetUser } from "@/api";
import UserRolesFormComponent from "./user-roles-form.vue";
import UserDetailsFormComponent from "./user-details-form.vue";
import UserLoginFormComponent from "./user-login-form.vue";
import { UserInterface } from '@/utils/UserInterface';

@Component({
	components: {
		RimRepairLayoutComponent,
		UserRolesFormComponent,
		UserLoginFormComponent,
		UserDetailsFormComponent
	}
})
export default class UserFormComponent extends Vue {
	public user: IUser = makeUser({});
	public tab: number | null = null;
	public valid = true;
	public buttonLoading = false;
	public id: number | null = null;

	private UI__: UserInterface;

	async mounted() {
		this.UI__ = new UserInterface(this);

		this.id = +this.$route.params.id || null;
		if (this.id) {
			this.getUser();
		}
	}

	async getUser() {
		if (this.id) {
			this.UI__.TurnBlockerOn();
			this.buttonLoading = true;
			const resp = await GetUser(this.id);
			this.UI__.TurnBlockerOff();
			if (resp.Ok) {
				this.user = resp.User;
			}
			this.buttonLoading = false;
		}
	}
  
	get title() {
		return this.id
			? "Editing User [" + this.user.Initials + "]"
			: "Insert New User";
	}

	// addRole(role: UserRoles) {
	// 	this.user.Roles.push(role);
	// 	console.log("add requested", role);
	// }

	// removeRole(role: UserRoles) {
	// 	console.log("remove requested", role);

	//   this.user.Roles = this.user.Roles.filter(r => r !== role);
	// }
}

